import { ApiException } from 'api/api-exeption';
import { createSubstore } from 'storeon-substore';
import type { Store } from 'store/types';
import { sendRequestLead } from './leads-actions';
import { SEND_LEAD_REQUEST, LEADS_STORE_NAME } from './leads-constants';
import { LeadRequest, LeadsStore } from './leads-types';

const INITIAL_STATE: LeadsStore = {
  error: null,
  loading: false,
  applicationId: null,
  leadRequestStatus: null,
  leadRequestError: null,
} as const;

export const leads = (parentStore: Store) => {
  const store = createSubstore(parentStore, LEADS_STORE_NAME);
  store.on('@init', () => INITIAL_STATE);

  store.on(SEND_LEAD_REQUEST.init, async (_, data: LeadRequest) => {
    const { modelJson, orchestratorHost, useCredentials, apiKey, requestID } = parentStore.get();

    if (!modelJson.model || !orchestratorHost) {
      return Promise.resolve();
    }

    store.dispatch(SEND_LEAD_REQUEST.request);
    try {
      const { leadId } = await sendRequestLead(data, modelJson.model.properties.regionId.toString(), {
        orchestratorHost,
        useCredentials,
        apiKey,
        requestID,
      });
      store.dispatch(SEND_LEAD_REQUEST.success, leadId);
    } catch (e) {
      if (e instanceof ApiException) {
        if (e.status === 409) {
          store.dispatch(SEND_LEAD_REQUEST.conflict);
        } else {
          store.dispatch(SEND_LEAD_REQUEST.failure, 'Возникла ошибка при отправке заявки на консультацию');
        }
      }
    }

    return Promise.resolve();
  });
  store.on(SEND_LEAD_REQUEST.request, state => ({
    ...state,
    leadRequestStatus: 'Pending',
    leadRequestError: null,
  }));
  store.on(SEND_LEAD_REQUEST.failure, (state, error) => ({
    ...state,
    leadRequestError: error,
    applicationId: null,
    leadRequestStatus: null,
  }));
  store.on(SEND_LEAD_REQUEST.success, (state, applicationId) => ({
    ...state,
    applicationId,
    leadRequestStatus: 'Created',
  }));
  store.on(SEND_LEAD_REQUEST.conflict, state => ({ ...state, leadRequestStatus: 'Conflict' }));
};
